export default __webpack_public_path__ + "6a7b61df55310abfa5d49c65d3b52488.png";